import React from 'react';

import { Event } from '../../interfaces';
import { getBlockName } from '../../utils';
import { useFleet } from '../../hooks';
import { EventTypeIdentifier, FleetUUIDs } from '../../enums';
import { Tooltip } from '../atoms';

interface Props {
  event: Event;
}

export function Geocode(props: Props) {
  const text = getBlockName(props.event);
  const fleet = useFleet();
  const isAthens = fleet.uuid === FleetUUIDs.Athens || fleet.uuid === FleetUUIDs.EuAthens;

  const blockMappings = fleet.global_route_block_mapping;

  if (isAthens && blockMappings) {
    const { block_name, route_direction } = props.event.metadata?.route_metadata ?? {};
    const stringForMatching = `${route_direction} ${block_name}`.toUpperCase();
    const eventType = props.event.event_type_identifier;

    let mappedBlockName = blockMappings[eventType]?.[stringForMatching];

    if (!mappedBlockName) {
      // Fallback to TEST event type if specific event type mapping is not found
      mappedBlockName = blockMappings[EventTypeIdentifier.TEST]?.[stringForMatching];
    }

    if (mappedBlockName) {
      return <Tooltip tooltip={text}>{mappedBlockName}</Tooltip>;
    }
  }

  return <>{text}</>;
}
